module.exports = __webpack_public_path__ + "e936533f700a474d26033fe263ce8236.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/age-gate-bg-420.jpg
// module id = 170
// module chunks = 0